import React from "react";
import Checkbox from "semantic-ui-react/dist/commonjs/modules/Checkbox";
import { Link } from "../../lib/Link";


export class AreaChecker extends React.Component {
  state = { updateId: 1 };
  selected = {};
  all = false;
  constructor(props) {
    super(props);
    this.state = this.getState(props);
  }
  getState(props) {
    this.selected = {};
    if (props.value) {
      props.value.forEach(item => {
        this.selected[item] = true;
      });
    }
    return { updateId: this.state.updateId + 1 };
  }
  componentWillReceiveProps(newProps) {
    this.setState(this.getState(newProps));
  }
  onCheck(slug, checked) {
    if (!checked && this.all) {
      for (const city of this.props.cities) {
        this.selected[city.slug] = true;
      }
      this.all = false;
    }
    if (this.all) {
    } else if (checked) {
      this.selected[slug] = true;
    } else {
      delete this.selected[slug];
    }
    const selectedKeys = Object.keys(this.selected);
//    console.log("selectedKeys", selectedKeys);
    this.props.onChangeValue(selectedKeys.length ? selectedKeys : null);
    this.setState({ updateId: this.state.updateId + 1 });
  }
  onCheckAll(checked) {
    if (checked) {
      this.selected = {};
      this.all = true;
    } else {
      this.selected = {};
      this.all = false;
    }
    const selectedKeys = Object.keys(this.selected);
    this.props.onChangeValue(selectedKeys.length ? selectedKeys : null);
    this.setState({ updateId: this.state.updateId + 1 });
  }
  render() {
    return (
      <div className="area_choice">
        {(() => {
          if (this.props.pref) {
            return (
              <div className="city_choice">
              <Checkbox
                label={`${this.props.pref && this.props.pref.name}全て(${this.props.count.all})`}
                onChange={(event, element) => {
                  this.onCheckAll(element.checked);
                }}
                checked={this.all}
              />
              </div>
            );
          } else {
            return null;
          }
        })()}
        {this.props.cities &&
          this.props.cities.map((city, index) => this.props.count[city.slug] && (
            <div className="city_choice">
              <Checkbox
                checked={this.selected[city.slug] || this.all}
                value={`${city.name}(${this.props.count[city.slug]})`}
                key={index}
                onChange={(event, element) => 
                  this.onCheck(city.slug, element.checked)
                }
              />
              <Link to={`/${this.props.pref.slug}/${city.slug}/`} className="city_link">
                {`${city.name}(${this.props.count[city.slug]})`}
              </Link>
            </div>
          ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/area/AreaChecker.jsx